import { render } from "./ApiPortalField.vue?vue&type=template&id=10647e83&scoped=true"
import script from "./ApiPortalField.vue?vue&type=script&lang=js"
export * from "./ApiPortalField.vue?vue&type=script&lang=js"

import "./ApiPortalField.vue?vue&type=style&index=0&id=10647e83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10647e83"]])

export default __exports__